import React, { useState, useEffect, useCallback, useMemo } from "react";
import { login, getAuthToken } from "./auth";
import NetworkIndicatorIcon from "../assets/icons/network-indicator-icon.svg";
import LLMIndicatorIcon from "../assets/icons/llm-indicator-icon.svg";
import VoiceIndicatorIcon from "../assets/icons/voice-indicator-icon.svg";

export default function ConnectionTest({ elConnected, micOn }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [apiConnected, setApiConnected] = useState(false);
  const [voiceConnected, setVoiceConnected] = useState(false);
  const [authToken, setAuthToken] = useState("");

  // Determine if star-enterprise mode (props provided)
  const isStarEnterprise = elConnected !== undefined;

  // Check Internet Connection
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [setIsOnline]);

  // Check API Connection (legacy – only when NOT star-enterprise)
  useEffect(() => {
    if (isStarEnterprise) return;
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
        setApiConnected(true);
      } catch (error) {
        console.error("Failed to login:", error);
        setApiConnected(false);
      }
    };

    performLogin();
  }, [
    isStarEnterprise,
    setApiConnected,
    setAuthToken,
    setApiConnected,
    setVoiceConnected,
    setAuthToken,
  ]);

  // Check Voice Connection (legacy – only when NOT star-enterprise)
  useEffect(() => {
    if (isStarEnterprise) return;
    const checkConnection = async () => {
      const openaiAPIKey = process.env.REACT_APP_OPENAI_API_KEY;

      try {
        const response = await fetch(
          "https://api.openai.com/v1/audio/transcriptions",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${openaiAPIKey}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.ok) {
          setVoiceConnected(true);
          console.log("Connection successful!");
        } else {
          setVoiceConnected(true);
          //   console.error("Connection failed. Status:", response.status);
        }
      } catch (error) {
        setVoiceConnected(false);
        console.error("Error:", error);
      }
    };

    checkConnection();
  }, [isStarEnterprise]);

  const netStyle = useMemo(() => {
    if (isOnline) {
      return { backgroundColor: "green" };
    } else {
      return { backgroundColor: "red" };
    }
  }, [isOnline]);

  const llmStyle = useMemo(() => {
    if (isStarEnterprise) {
      return { backgroundColor: elConnected ? "green" : "red" };
    }
    return {
      backgroundColor: isOnline && apiConnected ? "green" : "red",
    };
  }, [isOnline, apiConnected, isStarEnterprise, elConnected]);

  const voiceStyle = useMemo(() => {
    if (isStarEnterprise) {
      return { backgroundColor: micOn ? "green" : "red" };
    }
    return {
      backgroundColor: isOnline && voiceConnected ? "green" : "red",
    };
  }, [isOnline, voiceConnected, isStarEnterprise, micOn]);

  return (
    <div className="app__indicator">
      <div className="network-indicator indicator-item">
        <img src={NetworkIndicatorIcon} alt="" />
        <div className="indicator" style={netStyle}></div>
      </div>
      <div className="llm-indicator indicator-item">
        <img src={LLMIndicatorIcon} alt="" />
        <div className="indicator" style={llmStyle}></div>
      </div>
      <div className="voice-indicator indicator-item">
        <img src={VoiceIndicatorIcon} alt="" />
        <div className="indicator" style={voiceStyle}></div>
      </div>
    </div>
  );
}
